import { authenticate, getClient, getClientByType, setClientType } from "./client-manager.js";
// Default to rest
setClientType("rest");
// Default export that *looks like* a Feathers app and auto-forwards
const app = new Proxy({}, {
    get(_t, prop, receiver) {
        const target = getClient();
        return Reflect.get(target, prop, receiver);
    },
    set(_t, prop, value) {
        const target = getClient();
        return Reflect.set(target, prop, value);
    },
});
export default app;
// Power-user helpers (named exports)
export { authenticate, getClient, getClientByType, setClientType };
